import {} from "@/types/contexts/profile-context";
import { ScreenContextType } from "@/types/contexts/screen-context";
import { createContext } from "react";

const ScreenContext = createContext<undefined | ScreenContextType>(undefined);

export default ScreenContext;
